import { render, staticRenderFns } from "./services_more.vue?vue&type=template&id=5d140eab"
import script from "./services_more.vue?vue&type=script&lang=js"
export * from "./services_more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports